import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handlePostCommentRequest(
  state: State,
  { discussion, comment }: Boundaries["postComment"]["request"],
): State {
  return state.map((result) => ({
    ...result,
    discussions: result.discussions.map((d) =>
      d.uuid === discussion.uuid
        ? {
            ...d,
            comments: [
              ...d.comments,
              {
                ...comment,
                uuid: `__pending__${comment.content}`,
                createdDate: new Date().toISOString(),
              },
            ],
            commentsCount: (d.commentsCount ?? d.comments.length) + 1,
          }
        : d,
    ),
  }));
}

export { handlePostCommentRequest };
